import { LinkIcon, SuccessIcon } from "@packages/ds";
import styled, { keyframes } from "styled-components";

import { IconControl } from "ds/Button";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Share = styled(LinkIcon)`
  animation: 0.2s linear 1 ${fadeIn};
  fill: var(--mode-vector-neutral-default);
`;

export const Success = styled(SuccessIcon)`
  animation: 0.4s linear 1 ${fadeIn};
`;

export const IconCtr = styled(IconControl)`
  display: flex;
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const ShareContainer = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
`;
